// The row carries its own participant so the context menu can read it back off the click target.
interface ParticipantRow extends HTMLDivElement {
    participant: Participant;
}
